import request from '@/utils/request'

const base = (meetingCode) => `/user/admin/meeting/${encodeURIComponent(meetingCode)}/registration-subscriptions`
export const listSubscriptions = (meetingCode) => request({ url: base(meetingCode), method: 'GET' })
export const saveSubscription = (meetingCode, data) => request({ url: base(meetingCode), method: 'POST', data })
export const setSubscriptionEnabled = (meetingCode, id, enabled) =>
  request({ url: `${base(meetingCode)}/${id}/enabled`, method: 'POST', params: { enabled } })
export const testSubscription = (meetingCode, id) => request({ url: `${base(meetingCode)}/${id}/test`, method: 'POST' })
export const subscriptionRecords = (meetingCode, id, page) =>
  request({ url: `${base(meetingCode)}/${id}/records`, method: 'GET', params: { page, size: 20 } })
export const retrySubscriptionRecord = (meetingCode, id, deliveryId) =>
  request({ url: `${base(meetingCode)}/${id}/records/${deliveryId}/retry`, method: 'POST' })

export const probeSubscription = (meetingCode, id) =>
  request({ url: `${base(meetingCode)}/${id}/connectivity-test`, method: 'POST', timeout: 20000 })

export const resetSubscriptionSecret = (meetingCode, id) =>
  request({ url: `${base(meetingCode)}/${id}/reset-secret`, method: 'POST' })

export const pushSubscriptionHistory = (meetingCode, id, params) =>
  request({ url: `${base(meetingCode)}/${id}/history`, method: 'POST', params, timeout: 60000 })

export const deleteSubscription = (meetingCode, id) => request({ url: `${base(meetingCode)}/${id}`, method: 'DELETE' })
